import { useCallback } from 'react'
import useYam from '../bakery/useYam'
import { 
  voteNft, 
  getVoteForNFTContract, 
  getSushiAddress
 } from '../../sushi/utils'

 import { userNftAddress } from '../../userType/userNftAddress'
import { useActiveWeb3React } from '..'

const useVoting = (tokenId: string, nftType?: string, tokenOwner?: string) => {
  const {account} = useActiveWeb3React()
  const sushi = useYam()
  const voteForNFTContract = getVoteForNFTContract(sushi)
  const payToken = getSushiAddress(sushi)
  let nftToken = userNftAddress(sushi, nftType)

  const handleVoting = useCallback(
    async (amount: string) => {
      try {
        const txHash = await voteNft(
          voteForNFTContract,
          account,
          nftToken,
          payToken,
          tokenOwner,
          tokenId,
          amount
        )
        console.log(txHash)
        return txHash
      } catch (error) {
        return false
      }
    },
    [voteForNFTContract, account, tokenId, nftToken, payToken, tokenOwner]
  )

  return {onVote: handleVoting}
}

export default useVoting